import React from 'react'

const ChevronDown = ({
  color = '#5A6774',
  width = 24,
  height = 24,
  className,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <rect
        x="22.8"
        y="22.8"
        width="21.6"
        height="21.6"
        rx="10.8"
        transform="rotate(-180 22.8 22.8)"
        fill={color}
      />
      <rect
        x="22.8"
        y="22.8"
        width="21.6"
        height="21.6"
        rx="10.8"
        transform="rotate(-180 22.8 22.8)"
        stroke={color}
        strokeWidth="2.4"
      />
      <path
        d="M6.4 14.4L12 8.8L17.6 14.4"
        stroke="white"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default ChevronDown
